import {
  getItemFromLocalStorage,
  getItemFromLocalStorageWithoutPrefix,
  setItemInLocalStorage
} from "./use-local-storage";

const get2faStorageKey = email => `auth:2fa:medic-${email}:device-token`;
const getBrowserStrorageKey = email => `auth:nbc:medic-${email}`;

export default {
  twoFactorHeaderKey: "Semeia-Authentication-OTP",

  save2faTokenInStorage: (email: string, token: string): void => {
    setItemInLocalStorage(get2faStorageKey(email), token);
  },

  get2faTokenFromStorage: (email: string): string | null => {
    return getItemFromLocalStorage(get2faStorageKey(email));
  },

  clear2faTokenInStorage: (email: string): void => {
    getItemFromLocalStorage(get2faStorageKey(email));
  },

  getBrowserAuthToken: (email: string): string | null => {
    return getItemFromLocalStorage(getBrowserStrorageKey(email));
  },

  saveBrowserAuthToken: (email: string, token: string): void => {
    setItemInLocalStorage(getBrowserStrorageKey(email), token);
  },

  getRefreshTokenFromStorage: (): string | null => {
    const session = getItemFromLocalStorageWithoutPrefix(
      "ember_simple_auth-session"
    ) as string;
    return session !== undefined
      ? JSON.parse(session)?.authenticated?.refresh_token
      : null;
  }
};
